import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled, { css } from "styled-components";

import ScriptureHtmlView from "../ScriptureView/ScriptureHtmlView";
import ScriptureView from "../ScriptureView/ScriptureView";
import { chapterPath } from "../../utils/paths";
import { ScriptDirection } from "api/typedefs/Bible";
import { Passage as PassageType } from "../../api/typedefs/Passage";

interface PassageViewProps {
  ellipsize: boolean;
}

interface PassageProps {
  bibleId: string;
  passage: PassageType;
  scriptDirection?: ScriptDirection;
  link: boolean;
  ellipsize: boolean;
}

const PassageView = styled.div<PassageViewProps>`
  ${props =>
    props.ellipsize &&
    css`
      overflow: hidden;
      // text-overflow: ellipsis;
      max-height: 10em;
    `}
`;

const Passage: React.FC<PassageProps> = ({
  bibleId,
  passage,
  scriptDirection = "LTR",
  link = false,
  ellipsize = false
}) => {
  const location = useLocation();
  let scriptureView;

  if (typeof passage.content === "object") {
    scriptureView = (
      <ScriptureView
        bibleId={bibleId}
        content={passage.content}
        scriptDirection={scriptDirection}
        disableFootnotes={true}
        disableHighlights
        showVerseActions={false}
      />
    );
  } else {
    scriptureView = <ScriptureHtmlView content={passage.content} />;
  }

  const passageView = (
    <PassageView ellipsize={ellipsize}>
      <h3>{passage.reference}</h3>
      {scriptureView}
    </PassageView>
  );

  if (link) {
    const { chapterIds, orgId } = passage;
    return (
      <Link
        to={chapterPath({
          bibleId,
          chapterId: chapterIds[0],
          passageId: orgId,
          location
        })}
      >
        {passageView}
      </Link>
    );
  }

  return passageView;
};

export default Passage;
